import React from 'react';
import AdminUserProvider from './AdminUserContext';
import AdminUser from './AdminUser';

let Index = () => {
    return (
        <AdminUserProvider>
            <AdminUser />
        </AdminUserProvider>
    )
}

export default Index;